import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 's1-input-text',
  templateUrl: './s1-input-text.component.html',
  styleUrls: ['./s1-input-text.component.scss']
})
export class S1InputText implements OnInit {

  @Input() control: UntypedFormControl;
  @Input() label: string = '';
  @Input() readonly: boolean = false;
  @Input() type: string = 'text';
  @Input() isValid: boolean = true;
  @Input() grouped: boolean = true;
  @Input() appendLabel: string = '';
  @Input() textAlignment: string = 'text-left';

  constructor() { }

  ngOnInit(): void { }

  checkIsValid(): boolean {

    return this.control.valid || !this.control.touched;

  }

}
